module.exports = __webpack_public_path__ + "media/images/flags/kg-39c2e129f9d5f2602ec325dce9b7f1ee.svg";